import { useTheme } from "@/contexts/ThemeContext";
import { Sun, Moon, CircleHalf } from "@phosphor-icons/react";

/**
 * 3-state theme toggle: Auto → Light → Dark → Auto.
 *
 * Click cycles to the next state; the icon reflects the CURRENT state so
 * the user always sees what's active. Tooltip describes what the next
 * click will switch to (matches the language-switcher idiom of "what
 * I'll be" rather than "what I am").
 *
 * Visual scope: same height (h-9) and chrome as `LanguageSwitcher` so it
 * sits naturally next to it without forcing a layout change in the
 * surrounding header.
 */
export default function ThemeToggle({ testid = "theme-toggle" }) {
  const { theme, setTheme } = useTheme();
  const next = theme === "auto" ? "light" : theme === "light" ? "dark" : "auto";
  const Icon = theme === "light" ? Sun : theme === "dark" ? Moon : CircleHalf;
  const label =
    theme === "auto"  ? "Auto" :
    theme === "light" ? "Clair" : "Sombre";
  const title =
    next === "auto"   ? "Passer en mode automatique" :
    next === "light"  ? "Passer en mode clair" :
                        "Passer en mode sombre";

  return (
    <button
      type="button"
      data-testid={testid}
      data-theme-value={theme}
      onClick={() => setTheme(next)}
      title={title}
      aria-label={title}
      className="inline-flex items-center gap-1.5 h-9 px-2.5 rounded-md text-xs font-medium border border-zinc-700 bg-[#1A1A1A] text-zinc-200 hover:bg-zinc-800 hover:text-white focus:outline-none focus:ring-2 focus:ring-amber-500/40 transition-colors"
    >
      <Icon size={14} weight={theme === "auto" ? "regular" : "fill"} />
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
}
